import {
  type NavigatorAction,
  navigatorActions,
  type NavigatorState
} from '../context';

export const navigatorReducer = (
  state: NavigatorState,
  action: NavigatorAction
) => {
  let updatedState = state;
  switch (action.type) {
    case navigatorActions.SET_BACK_NAVIGATION: {
      const current = state.backNavigation;
      const next = action.payload;
      if (current?.path === next?.path && current?.context === next?.context) {
        return state;
      }
      updatedState = { ...state, backNavigation: next };
      break;
    }
    case navigatorActions.SET_LOGO_CLICKED:
      if (state.logoClicked === action.payload) return state;
      updatedState = { ...state, logoClicked: action.payload };
      break;
    case navigatorActions.SET_IS_ONLINE:
      // Every successful tRPC response reports online; only a change of
      // status may rerender the consumers (every post reads this).
      if (state.isOnline === action.payload) return state;
      updatedState = { ...state, isOnline: action.payload };
      break;
    default:
      return state;
  }
  return updatedState;
};
